import React, { FC, Fragment, MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Menu, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';

import { SocialAccount } from 'api';
import { getSocialAccountName } from 'helpers';

interface IProps {
  accounts: SocialAccount[];
  selectedAccount: SocialAccount;
  onConnect: () => void;
  onChange: (account: SocialAccount) => void;
}

const useStyles = makeStyles(theme => ({
  button: {
    paddingLeft: 0,
    fontSize: 16,
    lineHeight: '20px',
    transition: 'color 150ms ease-in-out',
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightBold,
  },
}));

const Accounts: FC<IProps> = ({ accounts, onChange, onConnect, selectedAccount }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const name = getSocialAccountName(selectedAccount);

  function handleOpen(event: MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleChange(connection: SocialAccount) {
    handleClose();
    onChange(connection);
  }

  function handleConnect() {
    handleClose();
    onConnect();
  }

  function renderAccount(account: SocialAccount) {
    const isSelected = account.id === selectedAccount.id;

    return (
      <MenuItem selected={isSelected} key={account.id} onClick={() => handleChange(account)}>
        {getSocialAccountName(account)}
      </MenuItem>
    );
  }

  return (
    <Fragment>
      <Button className={classes.button} onClick={handleOpen} endIcon={<ArrowDropDown />}>
        {name}
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {accounts.map(renderAccount)}
        <MenuItem onClick={handleConnect}>{t('sharing:connectAnother')}</MenuItem>
      </Menu>
    </Fragment>
  );
};

export default Accounts;
